import { render, staticRenderFns } from "./Deliverable-Line-Items.vue?vue&type=template&id=3fa06a48"
import script from "./Deliverable-Line-Items.vue?vue&type=script&lang=js"
export * from "./Deliverable-Line-Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports